module.exports = __webpack_public_path__ + "assets/img/AstonRX-Landing-Page-w960.fa0bbaa6.webp";